/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProfileFormDto } from './profile-form-dto';
import { FollowUsProperties } from './follow-us-properties';


export interface EngagementFlowProperties { 
    triggerOn?: string;
    minimumSpend?: number;
    customer1Action?: EngagementFlowProperties.Customer1ActionEnum;
    customer1AmountToIncrease?: number;
    customer1CampaignToAssign?: string;
    customer1MaxExecutions?: number;
    customer2Action?: EngagementFlowProperties.Customer2ActionEnum;
    customer2AmountToIncrease?: number;
    customer2CampaignToAssign?: string;
    ensureRegister?: boolean;
    sendDownloadEmail?: boolean;
    creditRate?: number;
    roundingMethod?: EngagementFlowProperties.RoundingMethodEnum;
    followUs?: FollowUsProperties;
    points?: number;
    recurrence?: EngagementFlowProperties.RecurrenceEnum;
    requiredFields?: Array<string>;
    form?: ProfileFormDto;
    customerMaxExecutions?: number;
    executeOnClick?: boolean;
}
export namespace EngagementFlowProperties {
    export const Customer1ActionEnum = {
        AssignCampaign: 'ASSIGN_CAMPAIGN',
        IncreaseBalance: 'INCREASE_BALANCE'
    } as const;
    export type Customer1ActionEnum = typeof Customer1ActionEnum[keyof typeof Customer1ActionEnum];
    export const Customer2ActionEnum = {
        AssignCampaign: 'ASSIGN_CAMPAIGN',
        IncreaseBalance: 'INCREASE_BALANCE'
    } as const;
    export type Customer2ActionEnum = typeof Customer2ActionEnum[keyof typeof Customer2ActionEnum];
    export const RoundingMethodEnum = {
        Ceil: 'ceil',
        Floor: 'floor',
        Round: 'round'
    } as const;
    export type RoundingMethodEnum = typeof RoundingMethodEnum[keyof typeof RoundingMethodEnum];
    export const RecurrenceEnum = {
        Once: 'once',
        Daily: 'daily',
        Weekly: 'weekly',
        Monthly: 'monthly',
        Quarterly: 'quarterly',
        Semiannually: 'semiannually',
        Yearly: 'yearly'
    } as const;
    export type RecurrenceEnum = typeof RecurrenceEnum[keyof typeof RecurrenceEnum];
}


